import { FunctionComponent } from 'react';
import { useMasterData } from 'hooks';
import SelectComponent, { SelectOption } from '../SelectComponent/SelectComponent';

interface MedicationMethodProps {
    selectedOption?: number;
    className?: string;
    onSelect: (option: number) => void;
}

const MedicationMethod: FunctionComponent<MedicationMethodProps> = props => {
    const { medicationMethodTypes } = useMasterData();

    return (
        <SelectComponent
            label="Method"
            selectedOption={
                props.selectedOption
                    ? {
                          id: Number(props.selectedOption),
                          name: ''
                      }
                    : undefined
            }
            options={medicationMethodTypes}
            placeholder="Select Method"
            className={props.className}
            required={true}
            onSelect={(option: SelectOption) => props.onSelect(Number(option.id.toString()))}
        />
    );
};

export default MedicationMethod;
